import React, { FC } from 'react'
import { getInitials } from 'components/Chat/helper'

interface ITackleAvatarLogo {
  className?: string
  padding?: string
  logo?: string
  firstName: string
  lastName: string
  textSize?: string
  textColor?: string
}

const TackleAvatarLogo: FC<ITackleAvatarLogo> = ({
  className,
  padding,
  logo,
  firstName,
  lastName,
  textSize = 'text-xl',
  textColor = 'text-white',
}) => {
  const initials = getInitials({ firstName, lastName })
  return (
    <div className="flex items-center justify-center">
      <span
        className={`rounded-full inline-flex justify-center items-center aspect-square flex-shrink-0 ${
          logo ? '!bg-white' : ''
        } ${className}`}
      >
        {logo ? (
          <img src={logo} className="object-cover w-full h-full rounded-full" alt="profile-pic" />
        ) : (
          <span
            className={`flex items-center justify-center ${textColor} font-bold uppercase ${textSize}`}
          >
            {initials}
          </span>
        )}
      </span>
    </div>
  )
}

TackleAvatarLogo.defaultProps = {
  padding: 'p-[6px]',
  className: 'bg-tertiary h-[50px] w-[50px]',
}
export default TackleAvatarLogo
